import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import LeadFormCRM from '../../../../components/LeadForm/LeadFormCRM';

function DamacRiversideSnapchatNina({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const images = [
        "/assets/images/projects/damac-riverside/1.webp",
        "/assets/images/projects/damac-riverside/2.webp",
        "/assets/images/projects/damac-riverside/3.webp",
        "/assets/images/projects/damac-riverside/4.webp"
    ];

    return (
        <>
            <div>
                <NoiseBackground />
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/offer/damac/riverside/en-s"
                        : "/offer/damac/riverside/ar-s"
                    }
                />
                {/* LIMITED TIME OFFER */}
                <div className="padding-container my-5 py-5">
                    <Countdown />
                </div>

                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                استثمر في دبي في أول مدينة بإطلالة على نهر يمتد لمسافة
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {/* {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "65,800 درهم"
                                            : "$17,900"
                                    } */}
                                    1500
                                </span>
                                متر – تجربة فاخرة بموقع مميز!
                            </h1>
                        ) : (
                            <h1 className="text-center px-2 my-1 text-xl">
                                Invest in Dubai’s First City with a
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {/* {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "AED 65,800"
                                            : "$17,900"
                                    } */}
                                    1500m
                                </span>
                                River View – Experience Luxury in a Prime Location!
                            </h1>
                        )
                    }
                </div>
            </div>
            {/* IMAGES */}
            <ImageSlider images={images} />
            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <LeadFormCRM
                    developer="Damac"
                    project="Riverside"
                    leadType="Apartment"
                    leadSource={"Snapchat"}
                    language={currentLang?.name}
                    enquiries={["1 Bedroom", "2 Bedrooms"]}
                />
            </div>
            <Footer />
        </>
    );
}

export default DamacRiversideSnapchatNina;
